import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import NoSearchResults from '../../../../../../../../libs/ui-design-system/src/foundations/icons/svgs/local-icons/no-search-results.svg';

const InvoiceTableEmptyState: React.FC = () => {
  return (
    <Stack
      spacing={0.4}
      sx={{
        alignItems: "center",
        justifyContent: 'center',
        height: '100%'
      }}>
      <Box
        sx={{
          position: "relative",
          width: 90,
          height: 62
        }}>
        <img src={NoSearchResults} alt="No search results found" />
      </Box>
      <Typography
        sx={{
          color: "text.primary",
          fontFamily: "Inter, sans-serif",
          fontWeight: "600",
          fontSize: "14px",
          paddingTop: "17px"
        }}>
        No search results found
      </Typography>
      <Typography
        sx={{
          color: "#7E8796",
          fontSize: "14px",
          fontWeight: "400"
        }}>
        Try double-checking your keywords or clearing filters.
      </Typography>
    </Stack>
  );
};

export default InvoiceTableEmptyState;
